import { render } from "./pageDangj.vue?vue&type=template&id=02556cf4&scoped=true"
import script from "./pageDangj.vue?vue&type=script&lang=js"
export * from "./pageDangj.vue?vue&type=script&lang=js"

import "./pageDangj.vue?vue&type=style&index=0&id=02556cf4&lang=scss&scoped=true"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02556cf4"]])

export default __exports__